import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const WorksIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الأعمال",
				breadcrumb: "الأعمال",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة عمل جديد",
					link: "/works/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/our_works/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			{data.map(item =>
				item.categories.map(category => (
					<div key={category.id}>
						<h1 className="itemTitle">{category.title}</h1>
						<div className="row">
							{category.posts.map(post => (
								<div key={post.id} className="col-md-3 col-6">
									<div className="serviceItem">
										{checkPermissions(["post-delete"]) && (
											<button
												onClick={() => handleDelete(post.id)}
												aria-label="حذف"
											>
												<i className="fas fa-trash"></i>
											</button>
										)}
										<Link
											to={
												checkPermissions(["post-edit"])
													? `/works/show/${post.id}`
													: "/"
											}
										>
											<img
												src={`${process.env.REACT_APP_MAIN_URL}${post.data.main_image}`}
												alt={post.data.title}
											/>
											<h1>{post.data.title}</h1>
										</Link>
									</div>
								</div>
							))}
						</div>
					</div>
				))
			)}
		</section>
	);
};

export default WorksIndex;
